export const hospitalServiceLinks = [
  { id: "hospital-overview", label: "معرفی کلی بیمارستان", path: "/aboutus" },
  {
    id: "hospital-emergency",
    label: "اورژانس شبانه‌روزی",
    path: "/appointment-booking",
  },
  {
    id: "hospital-checkup",
    label: "معاینه و واکسیناسیون",
    path: "/appointment-booking",
  },
  { id: "hospital-surgery", label: "جراحی و بستری", path: "/appointment-booking" },
  {
    id: "hospital-imaging",
    label: "تصویربرداری و آزمایشگاه",
    path: "/appointment-booking",
  },
];

export const navItems = [
  { id: "home", label: "خانه", path: "/" },
  { id: "store", label: "فروشگاه", type: "mega", columns: [] },
  {
    id: "hospital",
    label: "بیمارستان دامپزشکی",
    type: "dropdown",
    links: hospitalServiceLinks,
  },
  { id: "vet-booking", label: "رزرو دامپزشک", path: "/appointment-system" },
  { id: "blog", label: "وبلاگ", path: "/blog" },
  { id: "about", label: "درباره ما", path: "/aboutus" },
  { id: "contact", label: "تماس با ما", action: "scroll-footer" }
];

export const socialLinks = [
  { id: "instagram", label: "اینستاگرام", href: "https://www.instagram.com/", icon: "instagram" },
  { id: "whatsapp", label: "واتساپ", href: "https://wa.me/989000000000", icon: "whatsapp" },
  { id: "telegram", label: "تلگرام", href: "https://t.me/", icon: "telegram" }
];

